import { styled } from '../jss-style';
import messageStyle from './message';

const useMessageStyle = styled(messageStyle, 'message');
export { messageStyle, useMessageStyle };
export default useMessageStyle;
